export default {
  pageTitle: 'シェル取替えサービス',
  metaDescription: 'TEFは摩耗した熱交換器や容器のシェルを取り替えるシェル取替えサービスを提供し、機器を完全な稼働状態に回復させます。',
  sidebar: {
    heading: 'メンテナンス＆修繕一覧',
    weldingOverlay: '肉盛り溶接',
    patching: 'パッチ補修',
    piping: '配管',
    reshell: 'シェル取替え',
    retubing: 'チューブ取替え',
  },
  title: 'シェル取替え',
  heading: '熱交換器シェル取替え・溶接サービス',
  paragraph1: '当社は、熱交換器シェルの取替えにおいて高い信頼性と効率を実現する、専門的な溶接サービスをご提供いたします。設備の整った自社工場、またはお客様の現場のいずれにおいても、経験豊富な専門チームが業界標準を遵守しながら、精密な作業で工程全体に対応いたします。',
  paragraph2: '柔軟な対応によりダウンタイムを最小限に抑えながら、お客様の個別のニーズに合わせた高品質な仕上がりをお届けします。シームレスなシェル取替えと専門的な溶接サービスにより、熱交換器の健全性と機能を確実に回復いたします。',
  steps: {
    step1: 'シェル準備',
    step2: 'シェル焼鈍',
    step3: 'シェル切断',
    step4: 'シェル撤去',
    step5: 'シェル組立',
    step6: '耐圧試験',
    step7: 'シェルNDT検査',
  },
};
